<template>
  <label
    class="toggle"
    :class="{ 'toggle--disabled': disabled }"
  >
    <input
      v-model="value"
      class="checkbox"
      type="checkbox"
      :disabled="disabled"
    >

    <div
      class="toggle-container"
      :class="{'toggle-container--active': value}"
    >
      <div class="toggle-ball" />
    </div>

    <div class="toggle-label nds-text-p-bold">
      {{ label }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'ToggleElement',
  props: {
    label: String,
    // eslint-disable-next-line vue/prop-name-casing
    modelValue: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  emits: [
    'change',
    'update:modelValue',
  ],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(new_value) {
        if (this.disabled) {
          return;
        }

        this.$emit('update:modelValue', new_value);
        this.$emit('change');
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.toggle {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;

  &--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
}

.checkbox {
  display: none;
}

.toggle-container {
  background-color: $quartz;
  border: 1px solid $blue-haze;
  border-radius: 16px;
  height: 16px;
  width: 28px;

  .toggle-ball {
    background-color: $white;
    border: 1px solid $blue-haze;
    border-radius: 50%;
    height: 16px;
    margin-top: -1px;
    transform: translateX(-1px);
    transition: transform 0.3s;
    width: 16px;
  }

  &--active {
    background-color: $cornflower-blue;
    border: 1px solid $cornflower-blue;

    .toggle-ball {
      transform: translateX(11px);
    }
  }
}

.toggle:hover:not(.toggle--disabled) {
  .toggle-container {
    border: 1px solid $cornflower-blue;

    .toggle-ball {
      border: 1px solid $cornflower-blue;
    }

    &--active {
      background-color: $indigo;
      border: 1px solid $indigo;

      .toggle-ball {
        border: 1px solid $indigo;
      }
    }
  }
}
</style>
